import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { bindPromiseCreators } from 'redux-saga-routines';
import { reduxForm, Field, Form } from 'redux-form/immutable';
import Button from '@material-ui/core/Button';

import { showDialog, hideDialog, showWarning, showError } from '../../../redux/actions/dialogs';
import { fetchEmployeesPromise, fetchRolesRoutine } from '../../../redux/routines';
import { toJS } from '../../../utils/helper';
import { renderResourceEditor } from '../../../utils/reduxforms';
import { CONFIRM_DIALOG, CREATE_JOB_DIALOG, JOB_DIALOG, TASK_UPLOAD_DIALOG } from '../../../redux/constants/dialogs';

class Page3 extends React.Component {
  state = {};

  componentWillMount() {
    if (!this.props.roles) {
      this.props.fetchRoles();
    }
  }

  render() {
    const { handleSubmit, roles, showError, fetchEmployees } = this.props;

    return (<Form onSubmit={handleSubmit}>
      <Field
        name="resources"
        component={renderResourceEditor}
        roles={roles}
        showError={showError}
        fetchEmployees={fetchEmployees}
      />
    </Form>);
  }
}

Page3.propTypes = {
  roles: PropTypes.array,
  showDialog: PropTypes.func.isRequired,
  hideDialog: PropTypes.func.isRequired,
  showWarning: PropTypes.func.isRequired,
};

const form = reduxForm({
  form: CREATE_JOB_DIALOG, // <------ same form name
  destroyOnUnmount: true, // <------ preserve form data
  forceUnregisterOnUnmount: true, // <------ unregister fields on unmount
  // validate,
  onSubmitSuccess: (result, dispatch, props) => {
    // const context = {
    //   type: 'warning',
    //   title: 'Upload Tasks?',
    //   message: 'Would you like to upload tasks now?',
    //   confirm: 'Yes',
    //   onConfirm: () => props.showDialog(TASK_UPLOAD_DIALOG),
    //   reject: 'No',
    // };

    //TODO restore
    // props.showDialog(CONFIRM_DIALOG, context);
    props.hideDialog(CREATE_JOB_DIALOG);
    // props.onRequestClose();
  },
})(Page3);

function mapStateToProps(state) {
  return {
    roles: toJS(state.getIn(['roles', 'roles', 'data'])),
  };
}

function mapDispatchToProps(dispatch) {
  return {
    ...bindActionCreators({
      showDialog,
      hideDialog,
      showWarning,
      showError,
      fetchRoles: fetchRolesRoutine.trigger,
    }, dispatch),
    ...bindPromiseCreators({
      fetchEmployees: fetchEmployeesPromise,
    }, dispatch)
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(form);



// WEBPACK FOOTER //
// ./src/components/Jobs/CreateJobDialog/Page3.js